import { makeAutoObservable } from "mobx";
import {
  deletePatientFolder,
  pagingPatientFolder,
  saveOrUpdatePatientFolder,
  getPatientFolderById,
  addNewFilesPatientFolder,
  deletePatientFolderByDate,
  deleteFilesPatientInFolder,
  savePatientFolderVttech,
  voidFilePatientFolder,
} from "app/services/PatientFolder";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject, getDate } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import imageCompression from "browser-image-compression";
import {
  getFileById,
  uploadFile,
} from "app/services/FileDescriptionExtService";
import { config_resizeImg } from "app/common/LocalFunction";
import { UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER } from "app/appConfig";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class ImageGeneralTabStore {
  searchImageGeneral = {
    ...new SearchObject(),
    pageSize: PAGESIZE_ALL,
  };
  pageFolder = new PageResponse();
  folderSelectedView = null; // biến này dùng để lưu  folder nào đang view ra
  folderSelected = null;
  loadingFolderId = null;
  openFormCreateOrEditFolder = false;
  openConfirmDeleteFolder = null;
  openConfirmDeleteByDate = null;
  openConfirmDeleteAllDate = null;
  openConfirmDeleteSingleImage = null;

  constructor() {
    makeAutoObservable(this);
  }

  pagingPatientFolder = async () => {
    return await pagingPatientFolder(this.searchImageGeneral)
      .then(async ({ data }) => {
        this.pageFolder = data;
        if (data?.content?.length > 0 && !this.folderSelectedView) {
          await this.handleSelectFolder(data?.content[0]?.id);
        }
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thư mục khách hàng có lỗi");
      });
  };

  handleLoadFirstPatientFolder = async ({ patientId }) => {
    this.searchImageGeneral = {
      ...this.searchImageGeneral,
      patientId,
    };
    let data = await this.pagingPatientFolder();
  };

  handleChangeFormSearch = (searchImageGeneral) => {
    this.searchImageGeneral = {
      ...this.searchImageGeneral,
      searchImageGeneral,
    };
    this.pagingPatientFolder();
  };

  handleOpenFormCreateOrEdit = (id) => {
    if (Boolean(id)) {
      getPatientFolderById(id).then(({ data }) => {
        this.folderSelected = data;
        this.openFormCreateOrEditFolder = true;
      });
    } else {
      this.folderSelected = null;
      this.openFormCreateOrEditFolder = true;
    }
  };

  setLoadingFolderId = (id) => {
    this.loadingFolderId = id;
  };

  handleSelectFolder = async (id) => {
    if (id) {
      if (this.loadingFolderId === id) return;
      this.setLoadingFolderId(id);
      try {
        const { data } = await getPatientFolderById(id);
        let { fileDescriptionsByDate, ...ortherData } = data;
        let fileDescriptionsByDateFormat = await Promise.all(
          Object.entries(fileDescriptionsByDate || {}).map(
            async ([date, images]) => {
              const imagesWithBlob = await Promise.all(
                images?.map(async (img) => {
                  const blob = await getFileById(img.id);
                  const url = URL.createObjectURL(blob?.data);
                  return { ...img, url };
                })
              );
              return { date, images: imagesWithBlob };
            }
          )
        );

        this.folderSelectedView = {
          fileDescriptionsByDate: fileDescriptionsByDateFormat,
          ...ortherData,
        };
      } catch (error) {
        toast.error("Có lỗi xảy ra khi tải folder");
      } finally {
        this.setLoadingFolderId(null);
      }
    }
  };

  saveOrUpdatePatientFolder = async (obj) => {
    try {
      const { data } = await saveOrUpdatePatientFolder(obj);
      this.folderSelected = null;
      toast.success("Lưu thông tin thành công!");
      this.handleClosePopup();
      this.pagingPatientFolder();
    } catch (error) {
      console.error(error);
      toast.error("Lưu thông tin có lỗi");
    }
  };

  handleClosePopup = () => {
    this.openFormCreateOrEditFolder = false;
  };

  handleDelete = (id) => {
    this.openConfirmDeleteFolder = id;
  };

  handleCloseConfirmDelete = () => {
    this.openConfirmDeleteFolder = null;
  };

  handleConfirmDelete = async () => {
    try {
      const { data } = await deletePatientFolder(this.openConfirmDeleteFolder);
      if (data > 0) {
        toast.success("Xóa dữ liệu thư mục hàng thành công!");
        if (this.openConfirmDeleteFolder === this.folderSelectedView?.id) {
          this.folderSelectedView = null;
        }
      }
      this.handleCloseConfirmDelete();
      this.pagingPatientFolder();
    } catch (error) {
      console.error(error);
      toast.error("Xóa dữ liệu thư mục khách hàng có lỗi");
    }
  };

  handleUploadImageToFolder = async (values) => {
    let { patientId, id, files } = values;

    if (!files.length) return;
    if (files.length > UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER) {
      toast.warning(
        "Không được phép upload quá 1 lần " +
          UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER +
          " ảnh"
      );
      return;
    }

    try {
      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          const compressedBlob = await imageCompression(file, config_resizeImg);
          // Tạo lại file mới giữ nguyên tên gốc và type
          return new File([compressedBlob], file.name, { type: file.type });
        })
      );

      const uploadResponses = await Promise.all(
        compressedFiles.map((file) => uploadFile(file))
      );

      let formatData = {
        patientId,
        id,
        patientFileDescriptions: uploadResponses.map((el) => ({
          fileDescription: el?.data,
        })),
      };

      await addNewFilesPatientFolder(formatData);
      toast.success("Upload thành công");
      this.handleSelectFolder(this.folderSelectedView?.id);
      this.pagingPatientFolder();
    } catch (err) {
      console.error("Lỗi trong quá trình upload nhiều ảnh:", err);
    }
  };

  handleDeleteByDate = (date) => {
    this.openConfirmDeleteByDate = date;
  };
  handleCloseConfirmDeleteByDate = () => {
    this.openConfirmDeleteByDate = null;
  };

  handleConfirmDeleteByDate = async ({ patientId }) => {
    return await deletePatientFolderByDate({
      patientId,
      id: this.folderSelectedView?.id,
      filterDate: this.openConfirmDeleteByDate,
    })
      .then(() => {
        toast.success(
          `Xóa dữ liệu ảnh ngày ${getDate(
            this.openConfirmDeleteByDate
          )} thành công!`
        );

        let { fileDescriptionsByDate } = this.folderSelectedView;
        let newFileDescriptionsByDate = fileDescriptionsByDate.filter(
          (el) => el?.date !== this.openConfirmDeleteByDate
        );

        // tránh get lại folder vì dữ liệu khá là nhiều
        this.folderSelectedView = {
          ...this.folderSelectedView,
          fileDescriptionsByDate: newFileDescriptionsByDate,
        };
        this.handleCloseConfirmDeleteByDate();
        this.pagingPatientFolder();
      })
      .catch((err) => {
        console.error(err);
        toast.error(
          `Xóa dữ liệu ảnh ngày ${getDate(
            this.openConfirmDeleteByDate
          )} có lỗi!`
        );
      });
  };

  handleDeletAllDate = () => {
    this.openConfirmDeleteAllDate = true;
  };
  handleCloseConfirmDeleteAllDate = () => {
    this.openConfirmDeleteAllDate = null;
  };

  handleConfirmDeleteAllDate = async ({ patientId }) => {
    return await deleteFilesPatientInFolder({
      patientId,
      id: this.folderSelectedView?.id,
      voidedAll: true,
    })
      .then(() => {
        toast.success(`Xóa dữ liệu ảnh thành công!`);

        this.handleCloseConfirmDeleteAllDate();
        this.handleSelectFolder(this.folderSelectedView?.id);
        this.pagingPatientFolder();
      })
      .catch((err) => {
        console.error(err);
        toast.error(`Xóa dữ liệu ảnh có lỗi!`);
      });
  };

  handleSyncImageFromVttech = async (oldSystemId) => {
    try {
      const { data } = await savePatientFolderVttech(oldSystemId);
      toast.success("Đồng bộ dữ liệu ảnh thành công!");
      this.folderSelectedView = null;
      this.pagingPatientFolder();
    } catch (error) {
      console.error(error);
      toast.error("Đồng bộ dữ liệu ảnh có lỗi");
    }
  };

  handleDeletSingleImage = (obj) => {
    this.openConfirmDeleteSingleImage = obj;
  };
  handleCloseConfirmSingleImage = () => {
    this.openConfirmDeleteSingleImage = null;
  };

  handleDeleteSingleImage = async () => {
    try {
      let { date, idImage } = this.openConfirmDeleteSingleImage;
      const { data } = await voidFilePatientFolder(idImage);
      if (data) {
        let newFolderSelectedView =
          this.folderSelectedView?.fileDescriptionsByDate?.map((el) => {
            if (el?.date === date) {
              let newImages = el?.images?.filter((img) => img?.id !== idImage);
              return { ...el, images: newImages };
            }
            return el;
          });

        this.folderSelectedView = {
          ...this.folderSelectedView,
          fileDescriptionsByDate: newFolderSelectedView,
        };
        this.pagingPatientFolder();
        this.handleCloseConfirmSingleImage();
        toast.success(`Xóa dữ liệu ảnh thành công!`);
      } else {
        toast.error(`Xóa dữ liệu ảnh có lỗi!`);
      }
    } catch (error) {
      console.error(error);
      toast.error(`Xóa dữ liệu ảnh có lỗi!`);
    }
  };

  handleUploadImageByDate = async (values) => {
    let { patientId, id, files, updateCreateDate } = values;

    if (!files.length) return;
    if (files.length > UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER) {
      toast.warning(
        "Không được phép upload quá 1 lần " +
          UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER +
          " ảnh"
      );
      return;
    }

    try {
      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          const compressedBlob = await imageCompression(file, config_resizeImg);
          // Tạo lại file mới giữ nguyên tên gốc và type
          return new File([compressedBlob], file.name, { type: file.type });
        })
      );

      const uploadResponses = await Promise.all(
        compressedFiles.map((file) => uploadFile(file))
      );

      let formatData = {
        patientId,
        id,
        patientFileDescriptions: uploadResponses.map((el) => ({
          fileDescription: el?.data,
        })),
        updateCreateDate,
      };

      await addNewFilesPatientFolder(formatData);
      toast.success("Upload thành công");
      this.handleSelectFolder(this.folderSelectedView?.id);
      this.pagingPatientFolder();
    } catch (err) {
      console.error("Lỗi trong quá trình upload nhiều ảnh:", err);
    }
  };

  resetStore = () => {
    this.pageFolder = new PageResponse();
    this.folderSelectedView = null;
  };
}
